<template>
  <div>
    <list
      row-key="ExamId"
      ref="list"
      unit="考试管理"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="考试编码">
          <el-input v-model="params.ExamCode" size="mini" placeholder="请填写考试编码"></el-input>
        </el-form-item>
        <el-form-item label="入学年份">
          <el-date-picker
            size="mini"
            v-model="params.SchoolYear"
            type="year"
            value-format="yyyy"
            placeholder="选择年份"
            style="width:100%;" />
        </el-form-item>
        <!-- <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange" size="mini">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="年级">
          <el-select v-model="params.Grade" size="mini" clearable @change="gradeChange">
            <el-option v-for="item in gradeList" :key="item.GradeId" :value="item.Grade"></el-option>
          </el-select>
        </el-form-item> -->
      </template>
      <template slot="table">
        <el-table-column prop="ExamCode" label="考试编码" min-width="170" />
        <el-table-column prop="ExamType" label="考试类型">
          <template slot-scope="{row}">
            <span v-if="row.ExamType==0">阶段</span>
            <span v-else-if="row.ExamType==1">中考</span>
          </template>
        </el-table-column>
        <el-table-column prop="SchoolYear" label="入学年份" />
        <el-table-column prop="Sn" label="第几次考试">
          <template slot-scope="{row}">
            <span v-if="row.ExamType==0">{{row.Sn}}</span>
            <span v-else-if="row.ExamType==1">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="Grade" label="年级" />
        <el-table-column prop="UpDown" label="上/下学期">
          <template slot-scope="{row}">
            <span v-if="row.UpDown==0">上学期</span>
            <span v-else-if="row.UpDown==1">下学期</span>
          </template>
        </el-table-column>
        <el-table-column prop="ExamName" label="考试名称" min-width="100">
          <template slot-scope="{row}">
            <span v-if="row.ExamType==0">{{row.ExamName}}</span>
            <span v-else-if="row.ExamType==1">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="TermName" label="学期名称" min-width="130" />
        <slot name="column"></slot>
      </template>
    </list>
    <!-- <export-dialog ref="exportDialog" /> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import termApi from "@/api/ed/term";
// import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  props: {
    showQuery: {
      type: Boolean,
      default: true
    },
    page: {
      type: Boolean,
      default: true
    }
  },
  components: { 
    list,
    // exportDialog
  },
  data() {
    return {
      api: require("@/api/achieve/exam").default,
      params: {
        ExamCode: "",
        SchoolYear: "",
      },
      isMB: this.$store.state.isMB,
      termApi,
      termList: [],
      gradeList: [],
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    export() {
      this.$refs.exportDialog.open().then((that) => {
        that.getData(this.params);
      });
    },
  },
};
</script>